import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { type XeroSyncParams, xeroSyncApi } from '@/features/reports/xero/api';

export const xeroSyncKeys = {
    all: ['reports', 'xero-sync'] as const,
    list: (params: XeroSyncParams) => ['reports', 'xero-sync', params] as const,
};

/** How often the tab asks again while a run is under way: a run is a minute or two of reads. */
export const RUNNING_POLL_MS = 3_000;

/**
 * The tab's list (ALS-388). While a run is under way the tab asks again every few seconds, so the
 * findings arrive by themselves when it ends; otherwise it reads once. Switching a filter keeps the
 * list in place until the next one arrives, rather than blinking through an empty state.
 */
export const xeroSyncQuery = (params: XeroSyncParams) =>
    queryOptions({
        queryKey: xeroSyncKeys.list(params),
        queryFn: () => xeroSyncApi.get(params),
        placeholderData: keepPreviousData,
        refetchInterval: (query) => (query.state.data?.running ? RUNNING_POLL_MS : false),
    });
